import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "@mui/material";
export const SEARCH_BAR_DEBOUNCE_DELAY = 500;

interface SearchbarProps {
  placeholder: string;
  onChange?: (value: string) => void;
}

const Searchbar: React.FC<SearchbarProps> = ({ placeholder, onChange }) => {
  const handleDebounce = debounce((inputValue: string) => {
    if (onChange) {
      onChange(inputValue);
    }
  }, SEARCH_BAR_DEBOUNCE_DELAY);

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleDebounce(event.target.value);
  };

  return (
    <TextField
      onChange={handleSearchInputChange}
      variant="outlined"
      inputProps={{ "aria-label": placeholder }}
      placeholder={placeholder}
      sx={{
        height: "50px",
        minWidth: "512px",
        "& .MuiInputBase-input": {
          fontFamily: "Lato",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "500",
          heigth: "32px",
          lineHeight: "normal",
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#979899",
        },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment
            position="end"
            sx={{
              height: "32px",
              backgroundColor: "#E3E1FF",
              borderRadius: "0 20px 20px 0",
              padding: "0px 15px",
              margin: 0,
            }}
          >
            <SearchIcon sx={{ color: "#755FFA" }} />
          </InputAdornment>
        ),
        sx: {
          borderRadius: "20px",
          border: "#D0D1D3",
          height: "32px",
          padding: 0,
        },
      }}
    />
  );
};

export default Searchbar;
